const spacing = (top, right, bottom, left) => {
    const factor = 0.5;
    const unit = 'rem';
    if (top && right && bottom && left) {
        return `${factor * top}${unit} ${factor * right}${unit} ${
            factor * bottom
        }${unit} ${factor * left}${unit}`;
    }
    if (top && right && bottom) {
        return `${factor * top}${unit} ${factor * right}${unit} ${
            factor * bottom
        }${unit}`;
    }
    if (top && right) {
        return `${factor * top}${unit} ${factor * right}${unit}`;
    }
    return `${factor * top}${unit}`;
};

export default spacing;
